import type { ServiceContext } from "@prolarus/shared";
import { apiPut } from "@/lib/apiClient";
import { tryDelete, tryGet, tryUpdate } from "./_shared";

export interface PriceBookBrief {
  id: string;
  company_id: string;
  price_book_id: string;
  attachment_id: string | null;
  brief_content: string | null;
  status_id: string | null;
  created: string;
  modified: string;
  created_by: string | null;
  updated_by: string | null;
}

export interface PriceBookBriefInsert {
  price_book_id: string;
  attachment_id?: string | null;
  brief_content?: string | null;
  status_id?: string | null;
}

export interface PriceBookBriefUpdate {
  attachment_id?: string | null;
  brief_content?: string | null;
  status_id?: string | null;
}

export const priceBookBriefService = {
  getByPriceBook(priceBookId: string) {
    return tryGet<PriceBookBrief>(
      `/api/price-book-briefs/by-price-book/${encodeURIComponent(priceBookId)}`,
    );
  },

  async upsert(
    priceBookId: string,
    data: PriceBookBriefUpdate,
    _context: ServiceContext,
  ): Promise<{ data: PriceBookBrief | null; error: Error | null }> {
    try {
      const result = await apiPut<{ data: PriceBookBrief }>(
        `/api/price-book-briefs/by-price-book/${encodeURIComponent(priceBookId)}`,
        data,
      );
      return { data: result.data, error: null };
    } catch (err) {
      return { data: null, error: err instanceof Error ? err : new Error(String(err)) };
    }
  },

  updateContent(
    id: string,
    content: string,
    _snapshot: PriceBookBrief,
    _context: ServiceContext,
  ) {
    return tryUpdate<PriceBookBrief>(`/api/price-book-briefs/${encodeURIComponent(id)}/content`, {
      brief_content: content,
    });
  },

  delete(id: string, _snapshot: PriceBookBrief, _context: ServiceContext) {
    return tryDelete(`/api/price-book-briefs/${encodeURIComponent(id)}`);
  },
};
